// Sugalarm — theme-pack + entitlement wrappers (cycle 174, themes step 4).

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";

/** Cycle 5: a hosted image preset's resolved srcs (built server-side from
 *  THEME_PACK_CDN_BASE). Public + cosmetic — present for every image preset
 *  regardless of ownership; empty when no CDN base is configured. */
export interface ImagePreset {
  id: string;
  pack_id: string;
  light_src: string;
  dark_src: string;
  thumb_src: string;
}

export interface ThemePack {
  pack_id: string;
  title: string;
  description: string;
  price_display: string;
  is_free: boolean;
  preset_ids: string[];
  /** Server-computed for the authenticated caller (never client-trusted). */
  owned: boolean;
  /** Cycle 5: resolved srcs for this pack's image-kind presets (may be empty). */
  image_presets?: ImagePreset[];
}

export interface ThemePacksResponse {
  packs: ThemePack[];
}

export interface MyEntitlementsResponse {
  pack_ids: string[];
}

export function listPacks(): Promise<ApiResult<ThemePacksResponse>> {
  return request<ThemePacksResponse>("/api/theme-packs");
}

/** The restore source — the caller's owned pack ids (incl. "core"). */
export function myEntitlements(): Promise<ApiResult<MyEntitlementsResponse>> {
  return request<MyEntitlementsResponse>("/api/me/entitlements");
}

/** The single purchase seam. This cycle the server backs it with a
 *  dev-gated simulate-purchase; in production it 404s (→ "Coming soon")
 *  until step 5 wires a real payment rail to the same path. */
export function purchasePack(packId: string): Promise<ApiResult<unknown>> {
  return request<unknown>(
    `/api/theme-packs/${encodeURIComponent(packId)}/purchase`,
    { method: "POST" },
  );
}
